//清除富文本中html标签
export const removeHtmlTag = html => {
  html = html.replace(/(\n)/g, "");
  html = html.replace(/(\t)/g, "");
  html = html.replace(/(\r)/g, "");
  html = html.replace(/<\/?[^>]*>/g, "");
  html = html.replace(/\s*/g, "");
  html = html.replace(/&nbsp;/g, "");
  return html;
}


export const deepCopy = obj => {
  return JSON.parse(JSON.stringify(obj))
}



export const timeStampToDate = (timestamp,fmt) => {
  var date = new Date(timestamp);
	var o = {
		"M+": date.getMonth() + 1,                 //月份
		"d+": date.getDate(),                    //日
		"h+": date.getHours(),                   //小时
		"m+": date.getMinutes(),                 //分
		"s+": date.getSeconds(),                 //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"S": date.getMilliseconds()             //毫秒
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		}
	}
  return fmt;
}

//添加图片尺寸标记
export const addImageSizeSymbol = (imageUrl, width, height) => {
	if(!imageUrl){
		return imageUrl;
	}
	if(imageUrl.includes('repository/image')){
		  //解析后缀名
			const suffix = imageUrl.substring((imageUrl.lastIndexOf(".") + 1), imageUrl.length);

			//拼接图片尺寸标记
			const sizeSymbol = height? `_${width}x${height}.${suffix}` : `_${width}.${suffix}`;

      // //去掉多余的斜杠
      // if(useOrigin && useOrigin[useOrigin.length - 1] == '/') {
      //   useOrigin = useOrigin.substring(0, useOrigin.length - 1)
      // }

      //补充斜杠
			if(imageUrl.substring(0,1) !== '/'){
				imageUrl = '/' + imageUrl;
			}

			//如果链接带有_100x100.jpg这种格式，则替换成新的
			if(/\_\d+\x\d+\.\w+$/ig.test(imageUrl)){
				const targetSymbol = imageUrl.match(/\_(\d+)\x(\d+)\.(\w+)$/i);
				imageUrl = imageUrl.replace(targetSymbol[0], sizeSymbol);
			}else{
				imageUrl += sizeSymbol;
			}
	}
	return imageUrl + `?t=${Math.random()}`;
	// return imageUrl;
}



// WEBPACK FOOTER //
// ./src/utils/helper.js